let webgl;

/** Cached one-shot WebGL probe — the 3D layer only loads if this passes. */
export function supportsWebGL() {
  if (webgl !== undefined) return webgl;
  try {
    const canvas = document.createElement("canvas");
    webgl = Boolean(
      window.WebGLRenderingContext &&
        (canvas.getContext("webgl2") || canvas.getContext("webgl")),
    );
  } catch {
    webgl = false;
  }
  return webgl;
}

/** Run a callback when the main thread is next idle (with a hard deadline). */
export function onIdle(callback, timeout = 1200) {
  if (typeof window.requestIdleCallback === "function") {
    const id = window.requestIdleCallback(callback, { timeout });
    return () => window.cancelIdleCallback(id);
  }
  const id = window.setTimeout(callback, 400);
  return () => window.clearTimeout(id);
}
